import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './TopBar.css'; // External CSS

const TopBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
      <header className="th-header">
        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container th-container">
              <div className="topbar-row">
                {/* Logo */}
                <div className="col-auto">
                  <Link to="/">
                    <img
                      src="assets/img/hero/logo.jpg"
                      alt="Tourm"
                      className="topbar-logo"
                    />
                  </Link>
                </div>

                {/* Desktop Menu */}
                <div className="col-auto desktop-menu">
                  <nav className="main-menu">
                    <ul className="nav-links">
                      <li><Link to="/" className="active">Home</Link></li>
                      <li><Link to="/video">Videos</Link></li>
                      <li><Link to="/event">Events</Link></li>
                      <li><Link to="/community">Community</Link></li>
                    </ul>
                  </nav>
                </div>

                {/* Contact Button (Desktop Only) */}
                <div className="col-auto desktop-menu">
                  <Link to="/contact" className="th-btn th-icon">
                    Contact us
                  </Link>
                </div>

                {/* Hamburger Icon (Mobile Only) */}
                <div className="mobile-menu-icon">
                  <button onClick={toggleMobileMenu}>
                    {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
                  </button>
                </div>
              </div>
            </div>

            {/* Mobile Dropdown Menu */}
            {isMobileMenuOpen && (
              <div className="mobile-dropdown">
                <ul>
                  <li><Link to="/" onClick={toggleMobileMenu}>Home</Link></li>
                  <li><Link to="/video" onClick={toggleMobileMenu}>Videos</Link></li>
                  <li><Link to="/event" onClick={toggleMobileMenu}>Events</Link></li>
                  <li><Link to="/community" onClick={toggleMobileMenu}>Community</Link></li>
                  <li><Link to="/contact" onClick={toggleMobileMenu}>Contact us</Link></li>
                </ul>
              </div>
            )}

            <div className="logo-bg" data-mask-src="assets/img/logo_bg_mask.png"></div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default TopBar;
